import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button } from 'react-toolbox';
import { connect } from 'react-redux';
import RadioButtons from 'components/RadioButtons';
import S from 'modal.scss';
import PhaseType from 'types/phase';
import { getPhaseErrors } from '../../../../../../../../../reducers';

class SurplusMaterial extends Resetter(Validator(React.Component)) {
  state = {
    excessMaterials: this.props.excessMaterials || 'NO_EXCESS_MATERIALS',
    errors: {},
  };

  surplusMaterialsRef = React.createRef();

  componentDidMount() {
    this.surplusMaterialsRef.current.scrollIntoView(false);
  }

  handleSubmit = () => {
    this.props.updateFormData({
      excessMaterials: this.state.excessMaterials,
      tab: 6,
    });
  }

  handlePrevious = () => {
    this.props.updateFormData({
      excessMaterials: this.state.excessMaterials,
      tab: 3,
    });
  }

  handleExcessMaterialsChange = value => this.setState({ excessMaterials: value });

  render() {
    const { isSpanish } = this.props;
    const radioButtons = [
      {
        label: isSpanish ? 'No hubo exceso de materiales'
                         : 'There were no excess materials',
        value: 'NO_EXCESS_MATERIALS',
      },
      {
        label: isSpanish ? 'Cliente dispuesto a mantener el exceso de materiales'
                         : 'Customer willing to keep excess materials',
        value: 'CUSTOMER_WILLING_TO_KEEP_EXCESS',
      },
      {
        label: isSpanish ? 'El cliente debe regresar a la tienda para obtener un reembolso'
                         : 'Customer to return to store for a refund',
        value: 'CUSTOMER_RETURN_TO_STORE_FOR_REFUND',
      },
      {
        label: isSpanish ? "Regreso a la tienda: Programe la recogida de Lowe's"
                         : "Return to store: Schedule Lowe's pick-up",
        value: 'RETURN_TO_STORE_SCHEDULE_LOWES_PICKUP',
      },
    ];

    return (
      <div ref={this.surplusMaterialsRef}>
        <h6 className={S.signatureTitle}>{isSpanish ? 'Exceso de Materiales' : 'Excess Materials'}</h6>
        <RadioButtons
          required
          onChange={this.handleExcessMaterialsChange}
          selectedValue={this.state.excessMaterials}
          radioButtons={radioButtons}
          text={isSpanish ? 'Por favor, seleccione qué se debe hacer con el exceso de material restante:'
                          : 'Please select what should be done with remaining excess materials:'}
        />
        <Button
          label={isSpanish ? 'Próximo' : 'Next'}
          flat inverse ripple
          className={S.submit}
          onClick={this.handleSubmit}
        />
        <Button
          label={isSpanish ? 'Anterior' : 'Previous'}
          flat inverse ripple
          className={S.submit}
          onClick={this.handlePrevious}
        />
      </div>
    );
  }
}

SurplusMaterial.propTypes = {
  isSpanish: PropTypes.bool,
  phase: PhaseType.isRequired,
  errors: PropTypes.shape({
    signature: PropTypes.arrayOf(PropTypes.string),
    name: PropTypes.arrayOf(PropTypes.string),
  }),
};


export default connect(state => ({ errors: getPhaseErrors(state) }), {})(SurplusMaterial);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/SignCocModal/surplus_material.jsx